var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuscriptionPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7055 10.4211C13.8068 10.4211 11.9507 10.9841 10.372 12.039C8.79328 13.0938 7.56283 14.5932 6.83622 16.3473C6.10962 18.1015 5.91951 20.0317 6.28993 21.894C6.66035 23.7562 7.57466 25.4667 8.91724 26.8093C10.2598 28.1519 11.9704 29.0662 13.8326 29.4366C15.6948 29.8071 17.6251 29.6169 19.3792 28.8903C21.1334 28.1637 22.6327 26.9333 23.6876 25.3546C24.7424 23.7759 25.3055 21.9198 25.3055 20.0211L15.7055 20.0211L15.7055 10.4211Z",
    fill: "#426DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8929 17.2414C29.8929 15.8149 29.6119 14.4024 29.066 13.0845C28.5201 11.7666 27.72 10.5691 26.7113 9.56044C25.7027 8.55177 24.5052 7.75165 23.1873 7.20576C21.8694 6.65987 20.4569 6.37891 19.0304 6.37891V17.2414H29.8929Z",
    fill: "#426DD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    stroke: "#B7B7B7",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuscriptionPrice);
export default __webpack_public_path__ + "static/media/SuscriptionPrice.c49043ed27dc1972848b93b7c16b9e6d.svg";
export { ForwardRef as ReactComponent };